import { 
    FETCH_DOCTORS_EARNING,
    FETCH_DOCTORS__EARNING_SUCCESS,
    FETCH_DOCTORS__EARNING_FAILED,
  } from "../store/types";
  
  export const INITIAL_STATE = {
    doctorearnings:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const doctorearningreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_DOCTORS_EARNING:
        return {
          ...state,
          loading:true
        };
      case FETCH_DOCTORS__EARNING_SUCCESS:
        return {
          ...state,
          doctorearnings:action.payload,
          loading:false
        };
      case FETCH_DOCTORS__EARNING_FAILED:
        return {
          ...state,
          doctorearnings:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
        default:
        return state;
    
    }
  };